import { Wrench, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function MaintenancePage({ message }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col items-center justify-center px-6 text-center">
      <div className="max-w-lg w-full">
        <img src="/logo-hidrogv.png" alt="HidroGV" className="h-24 w-auto mx-auto mb-8 object-contain" />

        <div className="inline-flex items-center justify-center w-20 h-20 bg-[#FFD600] text-black mb-6 rounded-full">
          <Wrench size={36} strokeWidth={2.2} />
        </div>

        <div className="inline-block bg-[#FFD600]/10 border border-[#FFD600]/40 text-[#FFD600] text-xs font-bold uppercase tracking-widest px-3 py-1.5 mb-4">
          <Clock size={12} className="inline mr-1 -mt-0.5" /> Në rregullim
        </div>

        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-none mb-4">
          Faqja është <span className="text-[#FFD600]">pauzuar</span>
        </h1>

        <p className="text-neutral-300 text-lg mb-8 whitespace-pre-line">
          {message || "Faqja është në rregullim. Kthehemi së shpejti."}
        </p>

        <div className="border-t border-[#1F2B44] pt-6 text-sm text-neutral-500">
          <div>© {new Date().getFullYear()} HidroGV — Të gjitha të drejtat e rezervuara.</div>
          <div className="mt-3">
            <Link to="/login" data-testid="maintenance-login-link" className="text-[#FFD600] hover:underline text-xs uppercase tracking-widest">
              Hyrja e administratorit →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
